import { render, staticRenderFns } from "./PurchasePriceBreakdown.vue?vue&type=template&id=5b8fadc8&scoped=true"
import script from "./PurchasePriceBreakdown.vue?vue&type=script&lang=js"
export * from "./PurchasePriceBreakdown.vue?vue&type=script&lang=js"
import style0 from "./PurchasePriceBreakdown.vue?vue&type=style&index=0&id=5b8fadc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8fadc8",
  null
  
)

export default component.exports